import React from 'react';
import { Button, InputNumber, Space, ColorPicker } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';

const ThresholdEditor = ({ thresholds, onChange }) => {
  const steps = thresholds?.steps || [{ value: null, color: 'green' }];

  const handleAddThreshold = () => {
    onChange({
      ...thresholds,
      steps: [...steps, { value: 80, color: 'red' }]
    });
  };

  const handleRemoveThreshold = (index) => {
    onChange({
      ...thresholds,
      steps: steps.filter((_, i) => i !== index)
    });
  };

  const handleUpdateThreshold = (index, field, value) => {
    const newSteps = [...steps];
    newSteps[index] = { ...newSteps[index], [field]: value };
    onChange({
      ...thresholds,
      steps: newSteps
    });
  };

  return (
    <div>
      <Space direction="vertical" style={{ width: '100%' }}>
        {steps.map((step, index) => (
          <Space key={index}>
            <InputNumber
              value={step.value}
              onChange={val => handleUpdateThreshold(index, 'value', val)}
              placeholder="Base"
              style={{ width: 120 }}
              disabled={index === 0}
            />
            <ColorPicker
              value={step.color}
              onChange={(color) => handleUpdateThreshold(index, 'color', color.toHexString())}
            />
            {index > 0 && (
              <Button
                icon={<DeleteOutlined />}
                size="small"
                onClick={() => handleRemoveThreshold(index)}
              />
            )}
          </Space>
        ))}
        <Button
          icon={<PlusOutlined />}
          onClick={handleAddThreshold}
          size="small"
        >
          Add Threshold
        </Button>
      </Space>
    </div>
  );
};

export default ThresholdEditor;